<template>
    <admin-dashboard-layout>
        <v-data-table
            :search="search"
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="videos"
            :items-per-page="5"
            class="elevation-1"
            @click:row="handleClickRow"
        >
            <template v-slot:top>
                <v-text-field
                    v-model="search"
                    label="Search"
                    class="mx-4"
                ></v-text-field>
            </template>
            <template v-slot:item.tags="{ item }">
                <v-chip v-for="tag in item.tags" :key="`tags-`+item.id+tag.id">{{tag.title}}</v-chip>
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ moment(item.created_at).format('LLL') }}
            </template>
            <template v-slot:item.thumbnailUrl="{ item }">
                <video playsinline :src="item.thumbnailUrl ? item.thumbnailUrl : item.overlayUrl" width="100" />
            </template>
        </v-data-table>
    </admin-dashboard-layout>
</template>

<script>
    import AdminDashboardLayout from "../../../layouts/AdminDashboardLayout";
    import Video from "../../../models/admin/Video";

    export default {
        name: "users-index",
        components: {AdminDashboardLayout},
        data: function () {
            return {
                loading: false,
                videos: [],
                search: '',
                headers: [
                    {
                        text: '# ID',
                        align: 'start',
                        sortable: false,
                        value: 'id',
                    },
                    { text: 'Creator', value: 'creator.user.name' },
                    { text: 'thumbnail', value: 'thumbnailUrl' },
                    { text: 'tags', value: 'tags' },
                    { text: 'Created at', value: 'created_at' },
                ],
            }
        },
        methods: {
            handleClickRow(video) {
                this.$router.push({name: 'admin.videos.show', params: {id: video.id}})
            }
        },
        async mounted() {
            this.loading = true
            this.videos = await Video.include('tags', 'creator.user').get()
            this.loading = false
        },
    }
</script>

<style scoped>

</style>
